import { render, staticRenderFns } from "./CurrentLgbTeamMembersList.vue?vue&type=template&id=424a1e71"
import script from "./CurrentLgbTeamMembersList.vue?vue&type=script&lang=js"
export * from "./CurrentLgbTeamMembersList.vue?vue&type=script&lang=js"
import style0 from "./CurrentLgbTeamMembersList.vue?vue&type=style&index=0&id=424a1e71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports